import React, { useRef, useState, useEffect } from "react";
import { Tabs } from "antd";

const { TabPane } = Tabs;

export default function Matab({
  dataS,
  refresh,
  refreshApi,
  isLoading,
  setisLoading,
}) {
  const tabMenu = [
    { text: "All Job", step: 6, job_status: 1000 },
    { text: "No Assign M&M", step: 1, job_status: 33 },
    { text: "Assign to M&M", step: 2, job_status: 34 },
    { text: "No Assign Sub", step: 3, job_status: 1 },
    { text: "Assign Sub", step: 4, job_status: 2 },
    { text: "On Process", step: 5, job_status: 3 },
  ];
  const ActiveTab = 34;
  const [count, setcount] = useState({
    1000: 0,
    33: 0,
    34: 0,
    35: 0,
    1: 0,
    18: 0,
    2: 0,
    3: 0,
  });
  const [SelectJobstatus, setSelectJobstatus] = useState(34);
  const unmounted = useRef(false);
  const Showdatata = dataS.filter((data) => {
    if (SelectJobstatus !== 1000) {
      if (SelectJobstatus === 33) {
        return data.job_status === SelectJobstatus || data.job_status === 35;
      } else if (SelectJobstatus === 1) {
        return data.job_status === SelectJobstatus || data.job_status === 18;
      } else {
        return data.job_status === SelectJobstatus;
      }
    } else {
      return dataS;
    }
  });

  useEffect(() => {
    if (dataS.length > 0) {
      setcount((data) => ({ ...data, 1000: dataS.length }));
    } else {
      setcount((data) => ({ ...data, 1000: 0 }));
    }
    // filter
    function filterCount(jobStatus) {
      let count = 0;
      dataS.map((dataCount) => {
        if (dataCount.job_status === jobStatus) {
          count = count + 1;
        }
      });
      return count;
    }
    tabMenu.map((menus) => {
      if (menus.job_status !== 1000) {
        setcount((count) => ({
          ...count,
          [menus.job_status]: filterCount(menus.job_status),
          35: filterCount(35),
          18: filterCount(18),
        }));
      }
    });

    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataS]);
  return (
    <>
      <div className="container-fluid">
        <Tabs defaultActiveKey={ActiveTab} type="card" size="large">
          {tabMenu?.map((data) => (
            <TabPane
              tab={
                data.job_status === 33
                  ? `${data.text} (${count[data.job_status] + count[35]})`
                  : data.job_status === 1
                  ? `${data.text} (${count[data.job_status] + count[18]})`
                  : `${data.text} (${count[data.job_status]})`
              }
              key={data.job_status}
            />
          ))}
        </Tabs>
      </div>
    </>
  );
}
